<template>
    <div class="TTL-system-photos-box">
        <TutarialCategoryPanel
            ref="catePanel"
            :selected-id="param.cateid"
            @select-category="onCategorySelect"
            @categories-updated="onCategoriesUpdated"
        />

        <div class="TTL-photo-box">
            <div class="photo-header-box">
                <el-form inline="true">
                    <el-form-item>
                        <wcinput
                            :option="{ placeholder: '请输入教程名称', clearable: true, ischange: true, isinput: true, iskeydown: true, width: '250px' }"
                            :value="param.key"
                            @finish="(val) => {
                                if (val.type == 'input') { param.key = val.value; param.ischange = true; }
                                if (val.type == 'change') { param.key = val.value; param.ischange = true; }
                                if (val.type == 'keydown') GetList();
                            }"
                        />
                    </el-form-item>
                    <el-form-item>
                        <wcbutton :option="{ title: '搜索' }" @finish="GetList" />
                    </el-form-item>
                    <el-form-item>
                        <wcbutton :option="{ title: '添加教程' }" @finish="$parent.JUMPVIEW({ name: 'EsAddTutarial' })" />
                    </el-form-item>
                    <el-form-item>
                        <wcbutton :option="{ title: '添加分类' }" @finish="openCateDialogFromToolbar" />
                    </el-form-item>
                    <el-form-item>
                        <wcbutton :option="{ title: '重置', type: 'del' }" @finish="handleResetSearch" />
                    </el-form-item>
                    <el-form-item>
                        <wcbutton
                            :option="{ title: '取消选择', type: 'del' }"
                            v-if="childhandleparam.type == 'selecttutarial'"
                            @finish="() => {
                                childhandleparam.type = '';
                                childhandleparam.rollbackindex = '';
                                childhandleparam.rollbackobjname = '';
                            }"
                        />
                    </el-form-item>
                </el-form>
            </div>

            <div class="TTL-table top20" :ref="objloading">
                <el-table :data="list" stripe="true" empty-text="" @selection-change="selecttable">
                    <template v-slot:empty><el-empty description="暂无数据" /></template>
                    <el-table-column label="封面" align="center" min-width="120">
                        <template #default="scope">
                            <wcimage :option="{ size: 'middle' }" :value="scope.row.thumb" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="catename" label="教程分类" align="center" min-width="120" />
                    <el-table-column prop="name" label="教程名称" align="center" min-width="200" />
                    <el-table-column prop="inputtime" label="添加时间" align="center" min-width="140" />
                    <el-table-column label="操作" align="center" min-width="180" fixed="right">
                        <template #default="scope">
                            <div class="TTL-btn-info" v-if="childhandleparam.type != 'selecttutarial'">
                                <wcbutton :option="{ title: '编辑' }" @finish="EditTutarialData(scope.row.id)" />
                                <wcbutton :option="{ title: '删除', type: 'del' }" @finish="DelTutarial(scope.row.id)" class="left10" />
                            </div>
                            <div class="TTL-btn-info" v-if="childhandleparam.type == 'selecttutarial'">
                                <wcbutton
                                    :option="{ title: '选择教程' }"
                                    @finish="() => {
                                        $parent.JUMPVIEW({
                                            name: childhandleparam.rollbackobjname,
                                            param: {
                                                type: childhandleparam.type,
                                                index: childhandleparam.rollbackindex,
                                                data: scope.row,
                                            },
                                        });
                                        childhandleparam.type = '';
                                        childhandleparam.rollbackindex = '';
                                        childhandleparam.rollbackobjname = '';
                                    }"
                                />
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="TTL-page-box top20">
                <div class="TTL-page-box-in">
                    <div class="TTL-page TTL-page-right">
                        <wcpage
                            :row="param.rows"
                            :p="param.p"
                            :rollpage="param.rollpage"
                            @finish="(val) => {
                                param.p = val.p;
                                param.rollpage = val.rollpage;
                                GetList();
                            }"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import INTERFACE_MODEL_TUTARIAL from '@/Interface/Es/Tutarial';
import TutarialCategoryPanel from './components/TutarialCategoryPanel.vue';

export default {
    components: {
        TutarialCategoryPanel,
    },
    data() {
        return {
            objloading: 'tutarial',
            param: {
                cateid: '',
                key: '',
                p: 1,
                rollpage: 10,
                ischange: false,
                rows: 0,
            },
            list: [],
            childhandleparam: {
                type: '',
                rollbackobjname: '',
                rollbackindex: '',
            },
        };
    },
    mounted() {
        this.OnloadMethod(false);
    },
    methods: {
        OnloadMethod() {
            this.GetList();
        },
        BrotherComponentIn(data) {
            if (this.$refs.catePanel) this.$refs.catePanel.reloadCategories();
            this.GetList();
            if (data.param && data.param.childtype && data.param.childtype != '') {
                this.childhandleparam.type = data.param.childtype;
                this.childhandleparam.rollbackindex = data.param.rollbackindex;
                this.childhandleparam.rollbackobjname = data.param.rollbackobjname;
            }
        },
        openCateDialogFromToolbar() {
            if (this.$refs.catePanel) this.$refs.catePanel.openDialog();
        },
        onCategorySelect({ categoryId }) {
            const normalized = categoryId === '' || categoryId === null || categoryId === undefined ? '' : categoryId;
            this.param.cateid = normalized;
            this.param.p = 1;
            this.GetList();
        },
        onCategoriesUpdated(payload = {}) {
            if (payload && payload.clearSelection) this.param.cateid = '';
            this.GetList();
        },
        handleResetSearch() {
            this.param.cateid = '';
            this.param.key = '';
            this.param.p = 1;
            this.GetList();
        },
        GetList() {
            if (this.param.ischange) {
                this.param.ischange = false;
                this.param.p = 1;
                this.param.rollpage = 10;
            }
            var obj = this.$refs[this.objloading];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_TUTARIAL.GET_TUTARIAL_LIST(this.param).then((res) => {
                this.$loading.closeloading(obj);
                if (res.status > 0) return false;
                this.param.rows = res.data.count;
                this.list = res.data.list;
            });
        },
        selecttable(val) {
            for (var i = 0; i < this.list.length; i++) this.list[i].isshow = false;
            for (var i = 0; i < val.length; i++) val[i].isshow = true;
        },
        DelTutarial(id) {
            this.$confirm
                .confirm('确定要删除该教程吗？删除后不可恢复！', '删除提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
                .then(() => {
                    this.DelTutarialData(id);
                })
                .catch(() => {});
        },
        EditTutarialData(ids) {
            this.$parent.JUMPVIEW({ name: 'EsEditTutarial', param: { ids: ids } });
        },
        DelTutarialData(ids) {
            INTERFACE_MODEL_TUTARIAL.DEL_TUTARIA({ ids: ids }).then((res) => {
                if (res.status > 0) return false;
                this.param.ischange = true;
                this.GetList();
            });
        },
    },
};
</script>
<style scoped>
.TTL-system-photos-box {
    display: inline-flex;
    justify-content: space-between;
    padding-top: 10px;
    width: calc(100% - 10px);
    height: calc(100vh - 100px);
    min-height: 400px;
}
.TTL-photo-box {
    display: inline-block;
    width: calc(100% - 252px - 20px);
    height: 100%;
    overflow-y: auto;
}
.TTL-photo-box::-webkit-scrollbar {
    width: 0;
}
.photo-header-box {
    display: inline-block;
    width: 100%;
    position: sticky;
    top: 0;
    background-color: #ffffff;
    z-index: 50;
    padding: 15px 0 0 0;
}
.TTL-btn-info {
    display: inline-flex;
}
</style>
